<template>

  <!-- ------------------------------ Alapadatok ------------------------------ -->

  <div v-if="hallgato.name != undefined">
    <h5 class="form-block-title-layout-tab" style="margin-top: 0px">
      <span>Alapadatok</span>
    </h5>
    <div class="row">
      <div class="col-md-6">
        <inputbox disabled="disabled" id="name" label="Név" name="name" v-model="hallgato.name"/>
        <inputbox disabled="disabled" id="birth_country" label="Születési ország" name="birth_country" v-model="hallgato.birth_country"/>
        <inputbox disabled="disabled" id="birthdate" label="Születési dátum" name="birthdate" v-model="hallgato.birthdate"/>
      </div>
      <div class="col-md-6">
        <inputbox disabled="disabled" id="neptuncode" label="Neptun kód" name="neptuncode" v-model="hallgato.neptuncode"/>
        <inputbox disabled="disabled" id="birth_place" label="Születési hely" name="birth_place" v-model="hallgato.birth_place"/>
        <inputbox disabled="disabled" id="nationality" label="Állampolgárság" name="nationality" v-model="hallgato.nationality"/>
      </div>
    </div>

    <!-- ------------------------------ Lakóhely adatok ------------------------------ -->

    <h5 class="form-block-title-layout-tab">
      <span>Lakóhely adatok</span>
    </h5>
    <div class="row">
      <div class="col-md-6">
        <inputbox disabled="disabled" id="country" label="Ország" name="country" v-model="hallgato.country"/>
        <inputbox disabled="disabled" id="city" label="Város" name="city" v-model="hallgato.city"/>
        <inputbox disabled="disabled" id="distance_gyor" label="Távolság Győrtől" name="distance_gyor" v-model="hallgato.distance_gyor"/>
      </div>
      <div class="col-md-6">
        <inputbox disabled="disabled" id="postcode" label="Irányítószám" name="postcode" v-model="hallgato.postcode"/>
        <inputbox disabled="disabled" id="address" label="Cím" name="address" v-model="hallgato.address"/>
        <inputbox disabled="disabled" id="distance_ovar" label="Távolság Mosonmagyaróvártól" name="distance_ovar" v-model="hallgato.distance_ovar"/>
      </div>
    </div>

    <!-- ------------------------------ Kapcsolat adatok ------------------------------ -->

    <h5 class="form-block-title-layout-tab">
      <span>Kapcsolat adatok</span>
    </h5>
    <div class="row">
      <div class="col-md-6">
        <inputbox disabled="disabled" regexp_filter="[0-9 +-/ ]+" id="phone_number" label="Telefonszám" name="phone_number" v-model="hallgato.phone_number"/>
      </div>
      <div class="col-md-6">
        <inputbox disabled="disabled" id="email" label="E-mail" name="email" v-model="hallgato.email"/>
      </div>
    </div>

    <!-- ------------------------------ Tanulmányok ------------------------------ -->

    <h5 class="form-block-title-layout-tab">
      <span>Tanulmányok</span>
    </h5>
    <table class="list-table">
      <tr>
        <th>Képzés kódja</th>
        <th>Képzés neve</th>
        <th>Tagozat</th>
        <th>Státusz</th>
        <th>Pü. státusz</th>
        <th>Szemeszter</th>
        <th>Átlag</th>
        <th>Szakátlag</th>
      </tr>
      <tr v-for="hallgato_szak in hallgato_szakok">
        <td>{{hallgato_szak.KepzesKod}}</td>
        <td>{{hallgato_szak.KepzesNev}}</td>
        <td>{{hallgato_szak.Tagozat}}</td>
        <td>{{hallgato_szak.Statusz}}</td>
        <td>{{hallgato_szak.PuStatusz}}</td>
        <td>{{hallgato_szak.Szemeszter}}</td>
        <td>{{hallgato_szak.Atlag}}</td>
        <td>{{hallgato_szak.Szakatlag}}</td>
      </tr>
    </table>
  </div>

</template>

<script>
import Vue from 'vue';

export default {
  components: {
  },

  data: function() {
    return {
      hallgato: {},
      hallgato_szakok: {},
      szocpontParameterek: {}
    }
  },
  mounted: function() {
    this.getHallgato();
  },
  methods: {
    getHallgato: function() {
      var _this = this;
      var neptun = this.$root.user.neptuncode;
      this.$root.ajax('hatar/getHallgato/' + neptun, {
        method: 'GET',
        success: function(response) {
          if (response.error == false) {
            _this.hallgato = response.student;
            _this.hallgato_szakok = response.studentTrainings;
            _this.szocpontParameterek = response.szocpontParameterek;
            _this.$emit('onReady',_this.hallgato,_this.hallgato_szakok,_this.szocpontParameterek);
          } else
            swal(response.error,'A pályázat nem tölthető ki!','error');
        }
      });
    }
  }
}

</script>


// WEBPACK FOOTER //
// hatar_hallgato_adatok.vue?4dadae48